export default {"src":"/_next/static/media/ampl.737bee33.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};